import './navigation';
import './slider';
import './form-thank-you';
import './faq';
import './contact_module';
import './plan-select';

window.addEventListener('DOMContentLoaded', () => {
  // alert('somestuff')
});
